import styled from 'styled-components';
import { Steps as AntdSteps } from 'antd';
import { StepsProps } from 'antd/lib/steps';

type StepChildren = {
  children: React.ReactNode;
};

type StepCustomProps = StepsProps | StepChildren;

export const Container = styled.div`
  padding: 1rem 1rem 0 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  box-shadow: ${({ theme }) => theme.commoms.boxShadow};
  border: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 1.5rem;
    border-bottom: 0.4rem solid ${({ theme }) => theme.colors.gray8};
  }

  & .hefesto-step-by-step .hefesto-icon {
    width: 1rem;
  }
`;

export const TitleBox = styled.div`
  & > h2 {
    margin: unset;
    font-weight: bold;
  }

  & > span {
    font-size: 1rem;
  }
`;

export const Steps = styled(AntdSteps)<StepCustomProps>`
  width: 10rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 65%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    width: 45%;
  }
`;
